import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Request} from '../../models/request.model';
import {plainToClass} from 'class-transformer';
import {catchError, map} from 'rxjs/operators';
import {Helper} from '../utility/helper';
import {AuthenticationManager} from '../authentication/authenticationManager';
import {Router} from '@angular/router';
import { decode } from 'punycode';


@Injectable()
export class ApiService {

    constructor(private http: HttpClient, private authenticationManager: AuthenticationManager,private router: Router) {
    }


    public static formatErrors(error: HttpErrorResponse) {
        return throwError(() => error);
    }

    private setHeaders(): HttpHeaders {
        const headersConfig: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
            'Access-Control-Allow-Credentials': 'true',
            'Access-Control-Allow-Headers': 'Authorization,Content-Type',
            'Access-Control-Max-Age': '3600',
        };
        if (!Helper.isEmpty(this.authenticationManager.getAuthenticate())) {
            const authData = this.authenticationManager.getAuthenticate();
            if (authData?.accessToken) {
                headersConfig['Authorization'] = `Bearer ${authData.accessToken}`;
            }
            const checksum = authData.token;
            if (checksum) {
                headersConfig['Checksum'] = btoa(checksum);
            }
        }
        return new HttpHeaders(headersConfig);
    }
    

    
    private setRefTokenHeaders(): HttpHeaders {
        const headersConfig = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
            'Access-Control-Allow-Credentials': 'true',
            'Access-Control-Allow-Headers': 'Authorization,Content-Type',
            'Access-Control-Max-Age': '3600',
        };
        //return new HttpHeaders(headersConfig);

        if (!Helper.isEmpty(this.authenticationManager.getAuthenticate())) {
            const authData = this.authenticationManager.getAuthenticate();
            if (authData?.accessToken) {
                headersConfig['Authorization'] = `Bearer ${authData.accessToken}`;
            }
            const checksum = authData.token;
            if (checksum) {
                headersConfig['Checksum'] = btoa(checksum);
            }
        }
        return new HttpHeaders(headersConfig);
    }

    get(endpoint: string, request: Request): Observable<any> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeaders();
        return this.http.get(apiURL, { headers }).pipe(
            map((res: Response) => {
                return plainToClass(request.deserializerClass(), res as object);
            }),
            catchError((error) => {
                // if (error.status === 403 || error.status === 0) {
                //     localStorage.clear(); 
                //     sessionStorage.clear();
                //     // this.router.navigate(['/login'], { queryParams: { message: 'Logged out. Please log in again.' } });
                // }
                return ApiService.formatErrors(error);
            })
        );
    }
    
    getWithBody(endpoint: string, requestBody: any): Observable<any> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeaders();
    
        // Use the `request` method to send a GET request with a body
        return this.http.request('GET', apiURL, {
            body: requestBody, // Pass the body here
            headers: headers,
            observe: 'response'
        }).pipe(
            map((res: HttpResponse<any>) => {
                return res.body; // Return the response body
            }),
            catchError((error) => {
                // if (error.status === 403 || error.status === 0) {
                //     localStorage.clear(); 
                //     sessionStorage.clear();
                //     this.router.navigate(['/login'], { queryParams: { message: 'Logged out. Please log in again.' } });
                // }
                return ApiService.formatErrors(error);
            })
        );
    }
    
    post(endpoint: string, request: any): Observable<any> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeaders();
        return this.http.post(apiURL, request, { headers, observe: 'response' }).pipe(
            map((res: HttpResponse<any>) => {
                return res.body;
            }),
            catchError((error) => {
                // if (error.status === 403 || error.status === 0) {
                //     localStorage.clear(); 
                //     sessionStorage.clear();
                //     this.router.navigate(['/login'], { queryParams: { message: 'Logged out. Please log in again.' } });
                // }
                return ApiService.formatErrors(error);
            })
        );
    }

    refTokenPost(endpoint: string, request: any): Observable<any> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setRefTokenHeaders();
        return this.http.post(apiURL, request, { headers, observe: 'response' }).pipe(
            map((res: HttpResponse<any>) => {
                return res.body;
            }),
            catchError((error) => {
                // if (error.status === 403 || error.status === 0) {
                //     localStorage.clear(); 
                //     sessionStorage.clear();
                //     this.router.navigate(['/login'], { queryParams: { message: 'Logged out. Please log in again.' } });
                // }
                return ApiService.formatErrors(error);
            })
        );
    }
    

   
    put(endpoint: string, request: any): Observable<any> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeaders();
        return this.http.put(apiURL, request, { headers }).pipe(
            map((res: Response) => {
                return res;
            }),
            catchError((error) => {
                // if (error.status === 403 || error.status === 0) {
                //     localStorage.clear(); 
                //     sessionStorage.clear();
                //     this.router.navigate(['/login'], { queryParams: { message: 'Logged out. Please log in again.' } });
                // }
                return ApiService.formatErrors(error);
            })
        );
    }
    

    delete(endpoint: string, request: any): Observable<any> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeaders();
        return this.http.delete(apiURL, { headers, observe: 'response' }).pipe(
            map((res: HttpResponse<any>) => {
                return res.body;
            }),
            catchError((error) => {
                // if (error.status === 403 || error.status === 0) {
                //     localStorage.clear(); 
                //     sessionStorage.clear();
                //     this.router.navigate(['/login'], { queryParams: { message: 'Logged out. Please log in again.' } });
                // }
                return ApiService.formatErrors(error);
            })
        );
    }
    
    reportApi(apiURL: string, request: any): Observable<any> {
        const headers = this.setHeaders();
        return this.http.post(apiURL, request, { headers, responseType: 'blob' }).pipe(
            catchError((error) => {
                // if (error.status === 403 || error.status === 0) {
                //     localStorage.clear(); 
                //     sessionStorage.clear(); 
                //     this.router.navigate(['/login'], { queryParams: { message: 'Logged out. Please log in again.' } });
                // }
                return ApiService.formatErrors(error);
            })
        );
    }
    

      // new postMehod and headerMethod for file upload 
      private setHeadersForFileUplaod(): HttpHeaders {
        const headersConfig = {
            'Accept': 'application/json' ,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
            'Access-Control-Allow-Credentials': 'true',
            'Access-Control-Allow-Headers': 'Authorization,Content-Type',
            'Access-Control-Max-Age': '3600',
        };
       
        // if (!Helper.isEmpty(this.authenticationManager.getAuthenticate())) {
        //   // @ts-ignore
        //   headersConfig.Authorization = 'Bearer ' + this.authenticationManager.getAuthenticate().accessToken;
        // }
    
        // return new HttpHeaders(headersConfig);

        if (!Helper.isEmpty(this.authenticationManager.getAuthenticate())) {
            const authData = this.authenticationManager.getAuthenticate();
            if (authData?.accessToken) {
                headersConfig['Authorization'] = `Bearer ${authData.accessToken}`;
            }
            const checksum = authData.token;
            if (checksum) {
                headersConfig['Checksum'] = btoa(checksum);
            }
        }
        return new HttpHeaders(headersConfig);
      }


      private setFileHeaders(): HttpHeaders {
        const headersConfig = {
            'Accept': 'multipart/form-data' ,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
            'Access-Control-Allow-Credentials': 'true',
            'Access-Control-Allow-Headers': 'Authorization,Content-Type',
            'Access-Control-Max-Age': '3600',
        };
        if (!Helper.isEmpty(this.authenticationManager.getAuthenticate())) {
            const authData = this.authenticationManager.getAuthenticate();
            if (authData?.accessToken) {
                headersConfig['Authorization'] = `Bearer ${authData.accessToken}`;
            }
            const checksum = authData.token;
            if (checksum) {
                headersConfig['Checksum'] = btoa(checksum);
            }
        }
        return new HttpHeaders(headersConfig);
    }

    
    postForFileUplaod(endpoint: string, formData: FormData): Observable<any> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeadersForFileUplaod();
        return this.http.post(apiURL, formData, { headers, observe: 'response' }).pipe(
            map((res: HttpResponse<any>) => {
                return res.body;
            }),
            catchError((error) => {
                // if (error.status === 403 || error.status === 0) {
                //     localStorage.clear(); 
                //     sessionStorage.clear();
                //     this.router.navigate(['/login'], { queryParams: { message: 'Logged out. Please log in again.' } });
                // }
                return ApiService.formatErrors(error);
            })
        );
    }
    

    getForDownloadFile(endpoint: string, request: Request): Observable<Blob> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeaders();
        return this.http.get(apiURL, { headers, responseType: 'blob' }).pipe(
            map((res: Blob) => res),
            catchError((error) => {
                // if (error.status === 403 || error.status === 0) {
                //     localStorage.clear(); 
                //     sessionStorage.clear();
                //     this.router.navigate(['/login'], { queryParams: { message: 'Logged out. Please log in again.' } });
                // }
                return ApiService.formatErrors(error);
            })
        );
    }

    postForDownloadFile(endpoint: string, request: Request): Observable<Blob> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeaders();
        return this.http.post(apiURL, request, { headers, responseType: 'blob' }).pipe(
            map((res: Blob) => res),
            catchError((error) => {
                // if (error.status === 403 || error.status === 0) {
                //     localStorage.clear(); 
                //     sessionStorage.clear();
                //     this.router.navigate(['/login'], { queryParams: { message: 'Logged out. Please log in again.' } });
                // }
                return ApiService.formatErrors(error);
            })
        );
    }


    //Old Method before handle 403 error
    refTokenPostOld(endpoint: string, request: any): Observable<any> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setRefTokenHeaders();
        return this.http.post(apiURL, request, {headers, observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                return res.body;
            }),
            catchError(ApiService.formatErrors));
    }

    getOld(endpoint: string, request: Request): Observable<any> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeaders();
        return this.http.get(apiURL, {headers}).pipe(map((res: Response) => {
                return plainToClass(request.deserializerClass(), res as object);
            }),
            catchError(ApiService.formatErrors));
    }

    postOld(endpoint: string, request: any): Observable<any> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeaders();
        return this.http.post(apiURL, request, {headers, observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                return res.body;
            }),
            catchError(ApiService.formatErrors));
    }
    
    putOld(endpoint: string, request: any): Observable<any> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeaders();
        return this.http.put(apiURL, request, {headers}).pipe(map((res: Response) => {
                return res;
            }),
            catchError(ApiService.formatErrors));
    }

    reportApiOld(apiURL: string, request: any): Observable<any> {
        const headers = this.setHeaders();
        return this.http.post(apiURL, request, { headers, responseType: 'blob' }).pipe(
          catchError(ApiService.formatErrors)
        );
      }

    deleteOld(endpoint: string, request: any): Observable<any> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeaders();
        return this.http.delete(apiURL, {headers, observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                return res.body;
            }),
            catchError(ApiService.formatErrors));
    }

    postForFileUplaodOld(endpoint: string, formData: FormData): Observable<any> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeadersForFileUplaod();
        return this.http.post(apiURL, formData, {headers, observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                return res.body;
            }),
            catchError(ApiService.formatErrors));
    }

    getForDownloadFileOld(endpoint: string, request: Request): Observable<Blob> {
        const apiURL = `${environment.gateway_url}${endpoint}`;
        const headers = this.setHeaders();
        return this.http.get(apiURL, { headers, responseType: 'blob' }).pipe(
            map((res: Blob) => res),  
            catchError(ApiService.formatErrors)
        );
    }   
      

}
